var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3 11.4C16.6866 11.4 17 11.0866 17 10.7C17 10.3134 16.6866 10 16.3 10H7.7C7.3134 10 7 10.3134 7 10.7C7 11.0866 7.3134 11.4 7.7 11.4L16.3 11.4ZM16.3 14.4C16.6866 14.4 17 14.0866 17 13.7C17 13.3134 16.6866 13 16.3 13L7.7 13C7.3134 13 7 13.3134 7 13.7C7 14.0866 7.3134 14.4 7.7 14.4L16.3 14.4Z",
    fill: "#FFB500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityMedium);
export default __webpack_public_path__ + "static/media/priority-medium.0e74f80547c5966e88159240ae4149e0.svg";
export { ForwardRef as ReactComponent };